module.exports = __webpack_public_path__ + "static/media/selling-water-revenue-01.961be36b.jpg";